// Entrypoint фронтенда.
// Здесь делаем все одноразовые side-effects: dayjs locale, dayjs plugins.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { App } from "./App";

// Русская локаль для DatePicker / RangePicker.
dayjs.locale("ru");
// customParseFormat нужен для ручного ввода дат в DD.MM.YYYY (Admin Logs филтр).
dayjs.extend(customParseFormat);

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container #root not found in index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
